import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import StorefrontHeader from 'marketplace-ui-common/storefront/components/StorefrontHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export const HEADER_PADDING_Y = 48;
export default function HeaderSection({
  paddingBottom = HEADER_PADDING_Y
}) {
  const customStyle = useMemo(() => ({
    MAIN_SECTION_CLASSNAME: `p-top-${HEADER_PADDING_Y / 4}`,
    BACKGROUND_COLOR: '#FF5C35',
    GRADIENT_ANGLE: '225deg',
    START_GRADIENT_COLOR: '#FF5C35',
    END_GRADIENT_COLOR: '#F2545B',
    SEARCH_PADDING_BOTTOM: paddingBottom
  }), [paddingBottom]);
  return /*#__PURE__*/_jsx(StorefrontHeader, {
    collapsedTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.pageTitle"
    }),
    customStyle: customStyle,
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.pageSubtitle"
    }),
    testId: "storefront-header",
    title: /*#__PURE__*/_jsx(H1, {
      "aria-level": 1,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.pageTitle"
      })
    })
  });
}